import React, { useEffect, useRef, useState, useLayoutEffect } from "react";
import { useAppSelector, useAppDispatch } from "../../../app/hooks"
import { getAccountExpensePolicyRuleAsync, resetSelectedRecordObjectInState,deleteAllSelectedRecordExpensePolicyRuleAsync,updatePagination } from "./expensePolicyRuleSlice";
import ExpensePolicyRuleItem from "./ExpensePolicyRuleItem";
import ExpensePolicyRuleForm from "./ExpensePolicyRuleForm";
import { Link, useLocation } from 'react-router-dom';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import ExpensePolicyRuleOffCanvas from '../../../common/OffCanvas';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowToast } from "../../../common/Toastr";
import { useTranslation } from "react-i18next";
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useNavigate } from 'react-router-dom';
import Select, { StylesConfig } from 'react-select';
import CustomPagination from "../../../common/Pagination";
import { getPageSizeArray } from '../../../common/timeLiveFunction';
import { getFilteredList,sortData, getValueFromResource } from '../../../common/timeLiveFunction';
import Loader from '../../../common/Loader';
import PageSizeSelect from '../../../common/PageSizeSelect';

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}


const ExpensePolicyRule = ({onhandleOnClickEvent}:any) => {
     
    const dispatch = useAppDispatch();
    const modelRef = useRef<any>(null);
    const { t } = useTranslation();
    const { expensePolicyRuleList, isReload,isLoading, selectedRecord, sortOrder, sortColumn, search, pageNo, pageSize  } = useAppSelector((state) => state.expensePolicyRule)
    const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
    
    const { MasterExpensePolicyId} = useAppSelector((state) => state.expensePolicy);
    // const [pageSize, setPageSize] = useState(10);
    // const [currentPage, setCurrentPage] = useState(1);
    // const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { obj } = location.state || {};    
    const storedObjectData = localStorage.getItem('objExpensePolicyItem');
    const objectData = storedObjectData ? JSON.parse(storedObjectData) : null;


    let AccountExpensePolicyId = '00000000-0000-0000-0000-000000000000';
     if (MasterExpensePolicyId && MasterExpensePolicyId !== '') {
        AccountExpensePolicyId = MasterExpensePolicyId;
     } else if (obj && obj.AccountExpensePolicyId) {
        AccountExpensePolicyId = obj.AccountExpensePolicyId;
     } else if(objectData && objectData.AccountExpensePolicyId){
        AccountExpensePolicyId = objectData.AccountExpensePolicyId;
     }else
     {
         navigate('../expensepolicy');
     }
    
    
    useLayoutEffect(() => {
 
    }, [dispatch, location.pathname, menuList, navigate, pageId]);



    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    // const handlePageChange = (pageNumber: any) => {
    //     setCurrentPage(pageNumber);
    // };
    // const handleSearch = (event: any) => {
    //     const { value } = event.target;
    //     setSearchTerm(value);
    //     setCurrentPage(1);
    // };

    // const handlePageSizeChange = (selectedOption: any) => {
    //     const { value, label } = selectedOption;
    //     setPageSize(Number(value));
    //     setCurrentPage(1);
    // };

    const handlePageChange = (pageNumber: any) => {
        // setCurrentPage(pageNumber);
        let objects = {
            "pageSize": pageSize,
            "pageNo": pageNumber,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

    const handleSearch = (event: any) => {
        const { value } = event.target;
        // setSearchTerm(value);
        // setCurrentPage(1);
        let objects = {
            "pageSize": pageSize,
            "pageNo": 1,
            "search": value
        }
        dispatch(updatePagination(objects));
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        // setPageSize(Number(value));
        // setCurrentPage(1);
        let objects = {
            "pageSize": value,
            "pageNo": 1,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

    const filteredData: any = getFilteredList(expensePolicyRuleList, search);
    const indexOfLastItem = pageNo * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const currentItems = sortData(filteredData, sortOrder, sortColumn).slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = expensePolicyRuleList.length;
    const recordsFiltered = filteredData.length;


    // const filteredData: any = getFilteredList(expensePolicyRuleList, searchTerm);


    // const indexOfLastItem = currentPage * pageSize;
    // const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    // const totalItems = expensePolicyRuleList.length;
    // const recordsFiltered = filteredData.length;

    useEffect(() => {
        if (isReload) {
            dispatch(getAccountExpensePolicyRuleAsync(AccountExpensePolicyId));
        }
    }, [isReload])

    useEffect(() => {
        dispatch(getAccountExpensePolicyRuleAsync(AccountExpensePolicyId));
    }, [dispatch])

    const handleOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
        onhandleOnClickEvent({
            // "name": (t('Add Expense Rule')),
            "name": (Object.keys(selectedRecord).length > 0 ? getValueFromResource('Update ',dispatch, t) : getValueFromResource('Add ',dispatch, t)) + getValueFromResource('Expense Rule',dispatch, t),
            "width": "700px",
            "componentName": <ExpensePolicyRuleForm />
        });
    }

    const onDeleteSelectedClick = () => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAllSelectedRecordExpensePolicyRuleAsync(expensePolicyRuleList))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult[0].StatusCode === "200" ?
                                ShowToast("Expense policy deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult[0].ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {
                console.log("ShowSwalWithConfirmation:error ", error);
            });
    }
    
    return (
        <>
               {isLoading && <Loader />}

            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white">
                    <h3 className="card-title fw-bold headerTitle"  >
                        {/* {t('Rule List')} */}
                        {getValueFromResource('Rule List',dispatch, t)}
                        </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={search}
                                onChange={handleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search',dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"
                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                        {/* <Select
                                    styles={colourStyles}
                                    options={getPageSizeArray()}
                                    value={getPageSizeArray().find((option: any) => option.value == pageSize.toString())}
                                    onChange={handlePageSizeChange}
                                    className='fs-7 fw-normal'
                          /> */}
                           <PageSizeSelect onChange={handlePageSizeChange} />

                        </div>
                        {/* <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(currentItems.length > 0) ? (
                                <CustomPagination
                                    currentPage={pageNo}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={(pageNo - 1) * pageSize}
                                    t={t}
                                >
                                </CustomPagination>
                            ) : null}
                        </div> */}
                        {(currentItems.length > 0) && (
                            <>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <div>
                                    <CustomPagination
                                        currentPage={pageNo}
                                        onPageChange={handlePageChange}
                                        pageSize={pageSize}
                                        totalItems={totalItems}
                                        start={(pageNo - 1) * pageSize}
                                        t={t}
                                    />
                                </div>
                            </>
                        )}


                       
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                       
                          <a id="kt_OffCanvas" 
                            className='btn btn-sm btn-primary' 
                            style={{ marginRight: '2px', display: expensePolicyRuleList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                            onClick={handleOnClickEvent}>
                            <KTIcon iconName='plus' className='fs-3' />
                            {/* {t(`Add Expense Rule`)} */}
                            {getValueFromResource('Add Expense Rule',dispatch, t)}
                        </a>
                       
                            <>
                                <div className="text-muted me-5" style={{ marginRight: '2px', display: expensePolicyRuleList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                                    <span className="me-2" data-kt-user-table-select="selected_count">{expensePolicyRuleList.filter((item: any) => item.isSelected === 1).length}</span> 
                                    {/* {t('Selected')} */}
                                    {getValueFromResource('Selected',dispatch, t)}
                                </div>
                                <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
                                    style={{ marginRight: '2px', display: expensePolicyRuleList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                >
                                    <i className="bi bi-trash fs-5 me-2"></i>
                                    {/* {t('Delete')} */}
                                    {getValueFromResource('Delete',dispatch, t)}
                                </button>
                            </>
                       
                    </div>
                </div>
                
                {/* <div className="card-body"> */}
                <div className="card-Report-body">
                    <div className="table-responsive">
                        <ExpensePolicyRuleItem expensePolicyRuleList={filteredData} onopenModal={openModal} oncloseModal={closeModal} />
                    </div>
                </div>

            </div>
            
        </>
    )


}

export default ExpensePolicyRule;